import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {ALERTS_ID_KEY, ALERTS_LEGACY_ID_KEY} from "@/pages/alerting/AlertsPage.utils.ts";
import {AlertDetailsModal} from "@/pages/alerting/components/details/AlertDetailsModal.tsx";

interface ShowAlertDetailsActionProps {
  gas: GlobalAlertState;
  show: boolean;
  setShow: (show: boolean) => void;
  queryParams: URLSearchParams;
  setQueryParams: (params: URLSearchParams) => void;
}

export const ShowAlertDetailsAction = ({
  gas,
  show,
  setShow,
  queryParams,
  setQueryParams,
}: ShowAlertDetailsActionProps) => {
  return (
    <AlertDetailsModal
      id={gas.id}
      show={show}
      hide={() => {
        setShow(false);
        const params = new URLSearchParams(queryParams);
        params.delete(ALERTS_ID_KEY);
        params.delete(ALERTS_LEGACY_ID_KEY);
        setQueryParams(params);
      }}
    />
  );
};
